import React, { useEffect } from "react";
import { useState } from "react";
import { createUseStyles } from "react-jss";
import { sendMetriks } from "Services/sendMetriks";
import TariffOrderButton from "../TariffOrderButton/TariffOrderButton";
import VariantClientNumber from "../Variants/VariantClientNumber";
import VariantNewNumber from "../Variants/VariantNewNumber";
import VariantEsim from "../Variants/VariantEsim";
import VariantAbonent from "../Variants/VariantAbonent";

const useStyles = createUseStyles((theme) => ({
	wrapper: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
		padding: "35px 30px 40px",
		maxWidth: "380px",
		maxHeight: "640px",
		"& > *+*": {
			marginBottom: "15px",
		},
	},
	logoContainer: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	logo: {
		height: "70px",
	},
	title: {
		color: theme.palette.colors.purplishBlue,
		fontWeight: 700,
		fontSize: "20px",
		lineHeight: "24px",
		padding: "13px 0",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		wrapper: {
			maxWidth: "380px",
			flexWrap: "wrap",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		wrapper: {
			maxWidth: "350px",
		},
	},
	[`@media (max-width: ${theme.media.xs})`]: {
		wrapper: {
			maxWidth: "100%",
		},
	},
}));

function TariffOrderBlockContainer(props) {
	const [page, setPage] = useState(0);
	const { wrapper, logoContainer, logo, title } = useStyles();
	const { tariff, text } = props;

	let providerLogo = tariff.provider.logo;
	let tariffName = tariff.name;
	let tariffLink = props.connectURL;

	useEffect(() => {
		if (page == 1) {
			sendMetriks("POP_UP_OPERATOR_MNP");
		}
		if (page == 2) {
			sendMetriks("POP_UP_OPERATOR_SIM");
		}
		if (page == 3) {
			sendMetriks("POP_UP_OPERATOR_ESIM");
		}
		if (page == 4) {
			sendMetriks("POP_UP_OPERATOR_CHANGE");
		}
	}, [page]);

	function clickHandler(number) {
		setPage(number);
	}

	return (
		<>
			{page == 0 && (
				<div className={wrapper}>
					<div className={logoContainer}>
						<img className={logo} src={providerLogo} />
					</div>
					<h2 className={title} dangerouslySetInnerHTML={{ __html: tariffName }} />
					<TariffOrderButton text={text.GO_YOUR_NUMBER} clickHandler={() => clickHandler(1)} />
					<TariffOrderButton text={text.CONNECT_NEW_NUMBER} clickHandler={() => clickHandler(2)} />
					<TariffOrderButton text={text.ISSUE_ESIM} clickHandler={() => clickHandler(3)} />
					<TariffOrderButton
						text={text.CHANGE_TARIFF_OPERATOR}
						clickHandler={() => clickHandler(4)}
					/>
				</div>
			)}
			{page == 1 && (
				<VariantClientNumber
					link={tariffLink}
					clickBackHandler={() => clickHandler(0)}
					text={text}
				/>
			)}
			{page == 2 && (
				<VariantNewNumber link={tariffLink} clickBackHandler={() => clickHandler(0)} text={text} />
			)}
			{page == 3 && (
				<VariantEsim
					buttonFrame={props.buttonFrame}
					frame={props.frame}
					link={tariffLink}
					modalModel={props.modalModel}
					closeModalPoPup={props.closeModalPoPup}
					clickBackHandler={() => clickHandler(0)}
					text={text}
				/>
			)}
			{page == 4 && (
				<VariantAbonent link={tariffLink} clickBackHandler={() => clickHandler(0)} text={text} />
			)}
		</>
	);
}

export default TariffOrderBlockContainer;
